import React from 'react';
import Spinner from 'react-spinkit';

/**
 * A generic full screen loading page.
 */
const FullScreenLoading = () => (
  <div id='page-loader'>
    <Spinner fadeIn='none' name='circle' className='spinner' />
    <br />
    <span>
      Loading...
    </span>
  </div>
);

export default FullScreenLoading;



// WEBPACK FOOTER //
// ./src/containers/pages/full-screen-loading.js